import { RouteObject } from "../../../interfaces/navigation";
import EntryPoint from "../../../containers/Profile/Leads/EntryPointContainer";
import Detail from "../../../containers/Profile/MyPublications/Detail/EntryPointContainer";

export const leadsSubRoutes: RouteObject[] = [
    {
        title: "Gestión",
        path: ":id/management",
        component: <Detail/>
    }
];

export const leadsRoutes: RouteObject[] = [
    {
        title: "Mis Leads",
        path: "leads",
        component: <EntryPoint/>,
        subRoutes: leadsSubRoutes
    }
];